import React from 'react';

const FieldProductCode = ({goToExamples}) => {
  return (
    <div>
      <h4>
        Field [product_code]
      </h4>
      <p>
        GS1 GPC codes: originating country's product classification using the GS1 GPC codes (<a
        href="http://www.gs1.org/1/productssolutions/gdsn/gpc/browser/index.html"
        target="_blank">http://www.gs1.org/1/productssolutions/gdsn/gpc/browser/index.html</a>).
      </p>
      <p><strong>OPTIONAL</strong></p>
      <div>
        Example:
        <span className="pull-right">
          See also section: <a onClick={() => goToExamples()}>Examples of the product codes in XML</a>.
        </span>
      </div>
      <pre>
        <code className="language-xml">
          {`<recall lang="en" xmlns="urn:recall-schema">
  <product_code>
  <publication>2011-12-01</publication>
  </product_code>
  ...
</recall>
`}
        </code>
      </pre>
    </div>
  );
};

export default FieldProductCode;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/field-product-code.js